<section class="report-issue">
  <nz-modal
    (nzOnCancel)="handlerCancelClick()"
    [(nzVisible)]="isVisible"
    nzClassName="custom-report-issue-modal">
    <div *nzModalTitle>
      <h4 class="report-issue-title">Report About Issue</h4>
    </div>
    <div *nzModalContent>
      <form class="report-issue-form">
        <textarea
          [nzAutosize]="{ minRows: 2, maxRows: 6 }"
          nz-input
          [(ngModel)]="inputValue"
          name="report-issue"
          [placeholder]="'Describe The Issue'"></textarea>
      </form>
      <div class="footer">
        <button type="button" class="btn-cancel" (click)="handlerCancelClick()">
          Cancel
        </button>
        <button
          type="button"
          class="btn-confirm"
          [disabled]="!inputValue.length"
          (click)="handlerOkClick()">
          Send Report
        </button>
      </div>
    </div>
  </nz-modal>
</section>
